import React, { FC } from "react"
import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

import { PostsLandingSubscribeCalloutQueryQuery } from "@graphqlTypes"

import NewsletterForm from "@components/HubspotForm/presets/NewsletterForm"

import "./PostsLandingSubscribeCallout.scss"

const PostsLandingSubscribeCallout: FC = () => {
  const {
    backgroundImageData,
  } = useStaticQuery<PostsLandingSubscribeCalloutQueryQuery>(graphql`
    query PostsLandingSubscribeCalloutQuery {
      backgroundImageData: contentfulAsset(contentful_id: {eq: "4ygQERbmN2ivdg1BCWejtP"}) {
        imgixImage {
          gatsbyImageData(width: 395)
        }
      }
    }
  `)
  return (
    <div className="PostsLandingSubscribeCallout">
      {backgroundImageData?.imgixImage?.gatsbyImageData && (
        <GatsbyImage
          alt=""
          image={backgroundImageData.imgixImage.gatsbyImageData}
          style={{
            position: "absolute",
          }}
        />
      )}
      <div className="content">
        <h4 className="type--mono-M color--text-default">Stay up to date</h4>
        <h3>Our best content in your&nbsp;inbox</h3>
      </div>
      <NewsletterForm isCompact />
    </div>
  )
}

export default PostsLandingSubscribeCallout